const numericStat = (stat, key) => {
  const value = Number(stat?.[key] || 0);
  return Number.isFinite(value) ? Math.max(0, value) : 0;
};

export const summarizeOutboundVideoStats = (report) => {
  const summary = {
    reportAvailable: Boolean(report && typeof report.forEach === "function"),
    outboundVideoFound: false,
    bytesSent: 0,
    framesEncoded: 0,
    framesSent: 0,
    packetsSent: 0,
    frameWidth: 0,
    frameHeight: 0,
    framesPerSecond: 0,
    nackCount: 0,
    pliCount: 0,
    qualityLimitationReason: "none",
  };

  report?.forEach?.((stat) => {
    if (stat?.type !== "outbound-rtp" || stat.isRemote) return;
    const mediaKind = stat.kind || stat.mediaType;
    if (mediaKind && mediaKind !== "video") return;

    summary.outboundVideoFound = true;
    summary.bytesSent += numericStat(stat, "bytesSent");
    summary.framesEncoded += numericStat(stat, "framesEncoded");
    summary.framesSent += numericStat(stat, "framesSent");
    summary.packetsSent += numericStat(stat, "packetsSent");
    summary.frameWidth = Math.max(summary.frameWidth, numericStat(stat, "frameWidth"));
    summary.frameHeight = Math.max(summary.frameHeight, numericStat(stat, "frameHeight"));
    summary.framesPerSecond = Math.max(summary.framesPerSecond, numericStat(stat, "framesPerSecond"));
    summary.nackCount += numericStat(stat, "nackCount");
    summary.pliCount += numericStat(stat, "pliCount");
    if (stat.qualityLimitationReason) {
      summary.qualityLimitationReason = String(stat.qualityLimitationReason);
    }
  });

  return summary;
};

export const hasOutboundVideoData = (sample) => Boolean(
  sample?.outboundVideoFound && (
    sample.bytesSent > 0 ||
    sample.framesEncoded > 0 ||
    sample.framesSent > 0 ||
    sample.packetsSent > 0
  )
);

export const hasOutboundVideoProgress = (previous, current) => Boolean(
  previous && current && (
    current.bytesSent > previous.bytesSent ||
    current.framesEncoded > previous.framesEncoded ||
    current.framesSent > previous.framesSent ||
    current.packetsSent > previous.packetsSent
  )
);

export const summarizeOutboundAudioStats = (report) => {
  const summary = {
    reportAvailable: Boolean(report && typeof report.forEach === "function"),
    outboundAudioFound: false,
    bytesSent: 0,
    packetsSent: 0,
  };

  report?.forEach?.((stat) => {
    if (stat?.type !== "outbound-rtp" || stat.isRemote) return;
    const mediaKind = stat.kind || stat.mediaType;
    if (mediaKind && mediaKind !== "audio") return;
    summary.outboundAudioFound = true;
    summary.bytesSent += numericStat(stat, "bytesSent");
    summary.packetsSent += numericStat(stat, "packetsSent");
  });

  return summary;
};

export const hasOutboundAudioProgress = (previous, current) => Boolean(
  previous && current?.outboundAudioFound && (
    current.bytesSent > previous.bytesSent ||
    current.packetsSent > previous.packetsSent
  )
);
